// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"9656aaeb","726":"0e155020","808":"f5e11f70"}[chunkId] + ".chunk.css";
};